import axios from 'axios';

import {standardHeaders} from 'utils/requests';
import {User} from 'types/app/User';

// 定义合作申请的数据类型
export interface CooperationFormData {
  companyName: string;
  contactPerson: string;
  cooperationDetails: string;
  phone: string;
  wechat: string;
}

// 定义API响应类型
export interface CooperationResponse {
  code: string;
  message: string;
}

export async function createUser({
  display_name,
  email,
  password,
}: {
  display_name: string;
  email: string;
  password: string;
}) {
  return axios.post(`${process.env.REACT_APP_BACKEND_API}/users`, {display_name, email, password}, standardHeaders());
}

export async function getUser({uuid}: {uuid: string}): Promise<User> {
  const response = await axios.get<User>(`${process.env.REACT_APP_BACKEND_API}/users/${uuid}`);
  if (!response.data) {
    throw new Error('Error while fetching user. Please try again.');
  }
  return response.data;
}

/**
 * 申请合作API
 * @param data 合作申请表单数据
 * @returns Promise<CooperationResponse>
 */
export async function applyCooperate(data: CooperationFormData): Promise<CooperationResponse> {
  try {
    const response = await axios.post<CooperationResponse>(
      // `${process.env.REACT_APP_BACKEND_API}/cooperation/apply`,
      `/user/cooperate`,
      data,
      standardHeaders(),
    );

    if (!response.data) {
      throw new Error('申请提交失败，请稍后重试');
    }

    return response.data;
  } catch (error) {
    // 处理错误情况
    if (axios.isAxiosError(error)) {
      const errorMessage = error.response?.data?.message || '网络请求失败，请检查网络连接';
      throw new Error(errorMessage);
    }
    throw new Error('申请提交失败，请稍后重试');
  }
}
